const slugify = (str = '') => (
    str.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '')
);

module.exports = slugify;



// WEBPACK FOOTER //
// ./src/client/utils/slugify.js